import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Adv = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <div className="w-full h-full flex flex-col items-center justify-center p-2">
      <div className="flex flex-col h-[300px] w-[96%] sm:w-[60%] rounded-3xl bg-[#FC5EB2] text-white mx-auto mb-20">
        <h3 className="font-light text-4xl max-w-[670px] pt-[15px] pl-[15px] sm:pt-[40px] sm:pl-[40px] sm:mb-4">
          Win a Sephora beauty box worth $500!
        </h3>
        <div className="relative flex">
          <div className="pl-[15px] sm:pl-10">
            <p className="font-light xss:text-base xss:w-[220px] sm:text-xl sm:w-[500px] mb-5">
              Perform rituals daily and complete tasks to earn Beauty stars and
              get top positions on the leaderboard.
            </p>
            <p className="font-light text-base sm:w-[350px] w-[230px]">
              1st in the board will receive the box as a gift!
            </p>
          </div>
          <img
            loading="lazy"
            className="absolute right-0 bottom-[-41px] sm:right-0 sm:bottom-[-105px] h-[200px] sm:h-[290px] rounded-br-3xl"
            src="/advGirl.webp"
            alt="IphLeft"
          />
        </div>
      </div>

      <div className="relative w-[96%] sm:w-[60%] p-5 rounded-b-3xl bg-gradient-to-b from-[#FFFFFF] to-[#fcf3f8]">
        {/* Контент сверху */}
        <div ref={ref} className="relative z-10">
          <h1 className="text-2xl font-semibold mb-3">Meghan Millton</h1>
          <p className="text-md">Solvi Medical Director, PhD</p>
          <motion.div
            className="max-w-[300px] flex flex-col mb-2 rounded-2xl shadow-md bg-white p-4 items-center"
            initial={{ y: 0, opacity: 0 }} // начальное положение ниже блока
            animate={isInView ? { y: 0, opacity: 1 } : {}} // выезд на место
            transition={{ duration: 1.7, ease: "easeOut" }}
          >
            <div className="flex flex-col justify-between">
              <p className="text-sm">
                Solvi knows what products will fit your skin best out of{" "}
                <span className="font-bold">500K+ products</span> in our
                database
              </p>
              <img
                src="/signature.svg"
                alt="Signature"
                className="h-[70px] w-[70px] object-contain flex-shrink-0"
              />
            </div>
          </motion.div>
        </div>

        {/* Картинка снизу под контентом */}
        <img
          loading="lazy"
          src="/advWomen.webp"
          alt="Woman"
          className="absolute right-0 bottom-0 object-cover z-0 pointer-events-none"
        />
      </div>
    </div>
  );
};

export default Adv;
